import { Types } from '@store/types';

const initialState = [];

const SalesContractReducer = (state = initialState, action) => {
	switch (action.type) {
		case Types.STORE_SALES_CONTRACT_LIST:
			return [...initialState, ...action.payload];
		default:
			return state;
	}
};

export default SalesContractReducer;
